import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import { MMANavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';

// 2.15 MSDS INFORMATION

const SIMsdsInfo = () => {
	return (
		<>
			<Header plant="montgomery" />
			<main>
				<wrapper class="section-wrapper">
					<MMANavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item href="../../">Smart-Inspect</Breadcrumb.Item>
							<Breadcrumb.Item href="../overview">Warren Truck</Breadcrumb.Item>
							<Breadcrumb.Item active>MSDS Information</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<h2>MSDS INFORMATION</h2>
							<p>Material Safety Data Sheet (MDS) is a document provided by the manufacturer to provide personnel handling their materials with information regarding health and safety issues. The documents are to be located where they can be accessed by the end user. MDS sheets are dated material and, as such, may be updated periodically. Ensure you are referencing the most recent information available. Consult your company’s policy on how to obtain these documents.</p>
							<p>MDS is governed by OSHA (Occupational Safety & Health Administration) and additional information regarding MSDS requirements can be obtained by visiting their website.</p>
							<p>Refer to the Appendix section of this manual for the MSDS sheets.</p>
							<p>The MSDS is typically divided into the following (16) sixteen sections:</p>
							<ol>
								<li>Identification</li>
								<li>Hazard(s) Identification</li>
								<li>Composition / Information on Ingredients</li>
								<li>First-Aid Measures</li>
								<li>Fire-Fighting Measures</li>
								<li>Accidental Release Measures</li>
								<li>Handling and Storage</li>
								<li>Exposure Controls / Personal Protection</li>
								<li>Physical and Chemical Properties</li>
								<li>Stability and Reactivity</li>
								<li>Toxicological Information</li>
								<li>Ecological Information</li>
								<li>Disposal Considerations</li>
								<li>Transport Information</li>
								<li>Regulatory Information</li>
								<li>Additional Information</li>
							</ol>
							<p>Refer to the Appendix Section of this manual for MSDS sheets for the materials used in this system.</p>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SIMsdsInfo;
